import { useState } from "react";

import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";

import Joi from "joi-browser";
import DocumentUploadField from "./DocumentUploadField";

import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

const template = [
  {
    name: "fileName",
    label: "Document Name *",
    type: "text",
  },
  {
    name: "prompt",
    label: "Prompt",
    placeholder: "Example: all the details should be visible and readable",
    type: "textArea",
    style: { height: "100px", fontSize: "13px" },
  },
];

const schema = {
  fileName: Joi.string().required().label("Document Name"),
  prompt: Joi.string().allow(null, "").label("Prompt"),
};

export default function DocumentAddForm(props) {
  const { onDocumentAdd, onClose, open } = props;

  const [files, setFiles] = useState({
    file: "",
    isError: false,
  });
  const [loading, setLoading] = useState(false);

  const [inputField] = useState({
    fileName: "",
    prompt: "",
  })

  const { data, validate, handleChange, error, setError } = useForm(
    inputField,
    schema
  );

  const handleFileUpload = (files) => {
    const file = files.file;
    setFiles({
      file,
      isError: false,
    });
  };

  const handleFileRemove = (file) => {
    setFiles({
      file: "",
      isError: true,
    });
  };

  const isAddDisabled =
    Boolean(Object.keys(error).length) ||
    validate(data, schema) ||
    files.isError || !Boolean(files.file);

  const handleAddDocument = () => {
    const lifecycleCbs = {
      init: () => {
        setLoading(true);
        message.loading("Adding Reference document");
      },
      success: () => {
        message.destroy();
        message.success("Reference document added");
        onClose();
        setLoading(false);
      },
      error: (e) => {
        message.destroy();
        showErrorToast(e, "Failed to add referrence document");
        setLoading(false);
      },
    };

    const { fileName, prompt } = data;
    const payload = new FormData();

    payload.append(fileName, files.file);
    payload.append("prompt", prompt);

    onDocumentAdd(payload, lifecycleCbs);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Reference Document</DialogTitle>
      <DialogBody>
        <div className="flex flex-col gap-y-8">
          <Form
            data={data}
            error={error}
            template={template}
            handleChange={handleChange}
          />
          <DocumentUploadField
            files={files}
            fileUploadError={files.isError}
            onFileRemove={handleFileRemove}
            onFileUpload={handleFileUpload}
          />
        </div>
      </DialogBody>
      <DialogActions>
        <Button outline onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={handleAddDocument}
          loading={loading}
          disabled={isAddDisabled}
        >
          Add Document
        </Button>
      </DialogActions>
    </Dialog>
  );
}
